module.exports = __webpack_public_path__ + "img/delete-trash.d42510c7.png";